import { useEffect } from "react"

import DelayedCloseButton from "../../components/DelayedCloseButton/DelayedCloseButton"
import FeatureTermsList from "../../components/FeatureTermsList/FeatureTermsList"
import BubbleFeatureList from "../../components/BubbleFeatureList/BubbleFeatureList"
import Terms from "../../components/Terms/Terms"
import PaywallListFooter from "../../components/PaywallListFooter/PaywallListFooter"
import { useAppState } from "../../context/appStateContext"
import { useUltimateAlerts } from "../../context/ultimateAlertsContext"
import useStrings from "../../localization/useStrings"
import useQueryParams from "../../hooks/useQueryParams"
import native from "../../native/native"
import styles from "./AlternativeBottomPaywall.module.scss"
import { usePurchase } from "../../context/purchaseContext"

interface Props {
  onClose?: () => void
}

const BubbleFeatureTermsList = () => {
  return (
    <div className={styles.bubbleFeatureTermsList}>
      <BubbleFeatureList />
      <Terms />
    </div>
  )
}

const AlternativeBottomPaywall = ({ onClose }: Props) => {
  const { actions } = useAppState()
  const { showBubbleFeatures } = useQueryParams()

  useEffect(() => {
    actions.setFooterInsetColor("var(--background)")
  }, [])

  return (
    <div className={styles.container}>
      <Header onClose={onClose} />
      <div className={styles.scrollableList}>
        {showBubbleFeatures ? <BubbleFeatureTermsList /> : <FeatureTermsList />}
      </div>
      <PaywallListFooter />
    </div>
  )
}

const Header = ({ onClose }: Props) => {
  const strings = useStrings()
  const { actions } = useUltimateAlerts()
  const beforeYouGoEnabled = usePurchase().state.beforeYouGoEnabled
  const { showChoosePlanTitle } = useQueryParams()

  const handleClose = () => {
    if (onClose) {
      onClose()
      return
    }

    if (beforeYouGoEnabled) {
      actions.setShowBeforeYouGo(true)
    } else {
      native.postNativeEvent("close")
    }
  }

  const titleText = showChoosePlanTitle
    ? strings.choosePlanTitle
    : strings.title

  return (
    <div className={styles.headerContainer}>
      <DelayedCloseButton
        className={styles.closeButton}
        onClick={handleClose}
      />
      <img className={`yellowProLogo ${styles.logo}`} />
      <h1 className={styles.title} style={{ whiteSpace: "pre-line" }}>
        {titleText}
      </h1>
    </div>
  )
}

export default AlternativeBottomPaywall
